"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withSpacing;
exports.spacingPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var marginModifiers = (0, _utils.applyDynamicModifiers)('margin', function (_ref) {
  var margin = _ref.margin;
  return (0, _styledComponents.css)(["margin:", "px;"], _spacing.default.base * margin);
});
var marginBottomModifiers = (0, _utils.applyDynamicModifiers)('marginBottom', function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return (0, _styledComponents.css)(["margin-bottom:", "px;"], _spacing.default.base * marginBottom);
});
var marginLeftModifiers = (0, _utils.applyDynamicModifiers)('marginLeft', function (_ref3) {
  var marginLeft = _ref3.marginLeft;
  return (0, _styledComponents.css)(["margin-left:", "px;"], _spacing.default.base * marginLeft);
});
var marginRightModifiers = (0, _utils.applyDynamicModifiers)('marginRight', function (_ref4) {
  var marginRight = _ref4.marginRight;
  return (0, _styledComponents.css)(["margin-right:", "px;"], _spacing.default.base * marginRight);
});
var marginTopModifiers = (0, _utils.applyDynamicModifiers)('marginTop', function (_ref5) {
  var marginTop = _ref5.marginTop;
  return (0, _styledComponents.css)(["margin-top:", "px;"], _spacing.default.base * marginTop);
});
var marginXModifiers = (0, _utils.applyDynamicModifiers)('marginX', function (_ref6) {
  var marginX = _ref6.marginX;
  return (0, _styledComponents.css)(["margin-left:", "px;margin-right:", "px;"], _spacing.default.base * marginX, _spacing.default.base * marginX);
});
var marginYModifiers = (0, _utils.applyDynamicModifiers)('marginY', function (_ref7) {
  var marginY = _ref7.marginY;
  return (0, _styledComponents.css)(["margin-top:", "px;margin-bottom:", "px;"], _spacing.default.base * marginY, _spacing.default.base * marginY);
});
var paddingModifiers = (0, _utils.applyDynamicModifiers)('padding', function (_ref8) {
  var padding = _ref8.padding;
  return (0, _styledComponents.css)(["padding:", "px;"], _spacing.default.base * padding);
});
var paddingBottomModifiers = (0, _utils.applyDynamicModifiers)('paddingBottom', function (_ref9) {
  var paddingBottom = _ref9.paddingBottom;
  return (0, _styledComponents.css)(["padding-bottom:", "px;"], _spacing.default.base * paddingBottom);
});
var paddingLeftModifiers = (0, _utils.applyDynamicModifiers)('paddingLeft', function (_ref10) {
  var paddingLeft = _ref10.paddingLeft;
  return (0, _styledComponents.css)(["padding-left:", "px;"], _spacing.default.base * paddingLeft);
});
var paddingRightModifiers = (0, _utils.applyDynamicModifiers)('paddingRight', function (_ref11) {
  var paddingRight = _ref11.paddingRight;
  return (0, _styledComponents.css)(["padding-right:", "px;"], _spacing.default.base * paddingRight);
});
var paddingTopModifiers = (0, _utils.applyDynamicModifiers)('paddingTop', function (_ref12) {
  var paddingTop = _ref12.paddingTop;
  return (0, _styledComponents.css)(["padding-top:", "px;"], _spacing.default.base * paddingTop);
});
var paddingXModifiers = (0, _utils.applyDynamicModifiers)('paddingX', function (_ref13) {
  var paddingX = _ref13.paddingX;
  return (0, _styledComponents.css)(["padding-left:", "px;padding-right:", "px;"], _spacing.default.base * paddingX, _spacing.default.base * paddingX);
});
var paddingYModifiers = (0, _utils.applyDynamicModifiers)('paddingY', function (_ref14) {
  var paddingY = _ref14.paddingY;
  return (0, _styledComponents.css)(["padding-top:", "px;padding-bottom:", "px;"], _spacing.default.base * paddingY, _spacing.default.base * paddingY);
});

var spacingPropType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.objectOf(_propTypes.default.number)]);

var spacingPropTypes = {
  margin: spacingPropType,
  marginBottom: spacingPropType,
  marginLeft: spacingPropType,
  marginRight: spacingPropType,
  marginTop: spacingPropType,
  marginX: spacingPropType,
  marginY: spacingPropType,
  padding: spacingPropType,
  paddingBottom: spacingPropType,
  paddingLeft: spacingPropType,
  paddingRight: spacingPropType,
  paddingTop: spacingPropType,
  paddingX: spacingPropType,
  paddingY: spacingPropType
};
exports.spacingPropTypes = spacingPropTypes;

function withSpacing() {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], marginModifiers, marginBottomModifiers, marginLeftModifiers, marginRightModifiers, marginTopModifiers, marginXModifiers, marginYModifiers, paddingModifiers, paddingBottomModifiers, paddingLeftModifiers, paddingRightModifiers, paddingTopModifiers, paddingXModifiers, paddingYModifiers);
}